import { render, staticRenderFns } from "./PopupTestBookGraph.vue?vue&type=template&id=5317322b&scoped=true"
import script from "./PopupTestBookGraph.vue?vue&type=script&lang=js"
export * from "./PopupTestBookGraph.vue?vue&type=script&lang=js"
import style0 from "./PopupTestBookGraph.vue?vue&type=style&index=0&id=5317322b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5317322b",
  null
  
)

export default component.exports